import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.filter.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.find-index.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import { __spreadArray } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React from 'react';
import '../styles/index.less.js';
import { useMergedState } from 'rc-util';
import TiCheckBox from '../CheckBox/index.js';

var CheckBoxGroup = function CheckBoxGroup(props) {
  var _a = props.value,
    value = _a === void 0 ? [] : _a,
    onChange = props.onChange,
    _b = props.defaultValue,
    defaultValue = _b === void 0 ? [] : _b,
    _c = props.options,
    options = _c === void 0 ? [] : _c,
    disabled = props.disabled,
    style = props.style;
  var _d = useMergedState(defaultValue, {
      value: value,
      onChange: onChange
    }),
    checkeds = _d[0],
    setCheckeds = _d[1];
  var onCheckBoxChange = function onCheckBoxChange(event) {
    if (disabled) {
      return;
    }
    var current = event.target.value;
    if (checkeds.findIndex(function (x) {
      return x === current;
    }) > -1) {
      setCheckeds(function (state) {
        return state.filter(function (x) {
          return x !== current;
        });
      });
    } else {
      setCheckeds(function (state) {
        return __spreadArray(__spreadArray([], state, true), [current], false);
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "ti-checkbox-group",
    style: style
  }, options.map(function (x) {
    var isChecked = checkeds.findIndex(function (item) {
      return item === x.value;
    }) > -1;
    return /*#__PURE__*/React.createElement(TiCheckBox, {
      key: x.value,
      checked: isChecked,
      value: x.value,
      onChange: onCheckBoxChange,
      disabled: disabled || x.disabled
    }, x.label);
  }));
};

export { CheckBoxGroup as default };
